import { useLocalStore } from 'mobx-react-lite';

interface IModulesPresenter {
  isNeedHandleDeepLink: boolean;
  finishDeepLinkHandling(): void;
}

export function useModulesPresenter(): IModulesPresenter {
  const presenter = useLocalStore(() => ({
    isNeedHandleDeepLink: true,

    finishDeepLinkHandling(): void {
      presenter.isNeedHandleDeepLink = false;
    },
  }));

  return presenter;
}
